/*
Sohel 01/31/2023 2698951347 label changes
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Akhila 06/08/2023 2701335619 title label placeholder name change
Akhila 06/12/2023 2701335619 added role access
Phanee 08/02/2023 2701335619 Fixed dashboard data disable issue
*/
import React, {useState, useContext} from 'react';
import LandingPage from '../../../../Pages/LandingPage';
import SearchImportMRGroup from './SearchImportMRGroup';
import AddImportMRGroup from './AddImportMRGroup';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import DataManagerRecordGroupUsage from './DataManagerRecordGroupUsage';
import {useSelector} from 'react-redux';
import {EXPORT_DATA, IMPORT_DATA} from '../../../../constants/ReusableRoleAccess';

function ImportManagerRecordGroup() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [value, setValue] = useState(0);
  const [dataManagerRecordGroupData, setDataManagerRecordGroupData] = useState({});
  const {roleData} = useSelector(({role}) => role);
  const importRecordGroupAccess = roleData?.window?.[IMPORT_DATA]?.['IRG'];
  const exportRecordGroupAccess = roleData?.window?.[EXPORT_DATA]?.['ERG'];

  const [editExisting, setEditExisting] = useState(false);

  const tabLabels = ['Import Record Groups'];
  return (
    <>
      <LandingPage
        title={'Data Management'}
        showTabs={true}
        tabValue={0}
        handleTabChange={()=>{}}
        allAntTabs={tabLabels}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {value === 0 && (
                  <SearchImportMRGroup
                    setEditExisting={setEditExisting}
                    setValue={setValue}
                    setDataManagerRecordGroupData={setDataManagerRecordGroupData}
                    importRecordGroupAccess={importRecordGroupAccess}
                  />
                )}
                {value === 1 && (
                  <AddImportMRGroup
                    editExisting={editExisting}
                    importRecordGroupAccess={importRecordGroupAccess}
                    exportRecordGroupAccess={exportRecordGroupAccess}
                    setValue={setValue}
                  />
                )}
                {value === 2 && (
                  <DataManagerRecordGroupUsage
                    setValue={setValue}
                    dataManagerRecordGroupData={dataManagerRecordGroupData}
                    exportManagerRecordGroup={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default ImportManagerRecordGroup;
